import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addBanner } from "../bannersAdminSlice";
import BannerForm from "./BannerForm";

const fields = {
  title: "Информация",
  data: [
    {
      required: true,
      options: undefined,
      type: "image",
      title: "Банер",
      name: "image",
    },
    {
      required: true,
      options: undefined,
      type: "text",
      title: "Текст",
      name: "title",
    },
    {
      required: false,
      options: undefined,
      type: "text",
      title: "Линк",
      name: "link",
    },
    {
      required: false,
      options: undefined,
      type: "boolean",
      title: "Активен",
      name: "is_active",
      value: true,
    },
  ],
};

const AddBanner = () => {
  const dispatch = useDispatch();
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();
  const onSubmit = (data: any) => {
    if (data.image.file_name || data.image.file) {
      dispatch(
        addBanner(data, (event) => {
          setProgress(Math.round((100 * event.loaded) / event.total));
        })
      );
      navigate(-1);
    } else {
      alert("Добави снимка");
    }
  };

  return (
    <BannerForm
      formTitle="Добавяне на банер"
      onSubmit={onSubmit}
      fields={fields}
      progress={progress}
    />
  );
};

export default AddBanner;
